module.exports = __webpack_public_path__ + "static/media/6.24.73f30c9c.png";